import React, { useEffect } from 'react';
import { IEVChargingPageContent } from 'interfaces/chargingLocator';
import './EVChargingLocator.scss';
import { useEVChargingData } from 'hooks/useEVChargingData';
import useEVChargingPageContentData from 'hooks/useEVChargingPageContentData';
import ZipGateModal from 'components/Modal/ZipGateModal/ZipGateModal';
import ChargingLocatorContainer from 'components/ChargingLocator/ChargingLocatorContainer/ChargingLocatorContainer';
import useZipcode from 'hooks/useZipcode';

const EVChargingLocator = (): JSX.Element => {
  const { zipcode } = useZipcode();
  const pageContent = useEVChargingPageContentData();
  const stationData = useEVChargingData(zipcode);
  const isHonda = process.env.REACT_APP_THEME === 'honda';
  const brandVariation = isHonda
    ? 'ev-charging-locator-honda'
    : 'ev-charging-locator';

  const zipgatePageContent = {
    labels: {
      zipgateTitle: pageContent.data?.labels?.zipgateTitle || '',
      zipgateDescription: pageContent.data?.labels?.zipgateDescription || '',
      geolocationCta: pageContent.data?.labels?.geolocationCta || '',
      geolocationError: pageContent.data?.labels?.geolocationError || '',
      zipPlaceholder: pageContent.data?.labels?.zipPlaceholder || '',
      zipError: pageContent.data?.labels?.zipError || '',
    },
    mapBackground: {
      alternativeText:
        pageContent.data?.images.zipGateBackground?.alternativeText || '',
      sources: {
        medium:
          pageContent.data?.images?.zipGateBackground?.sources?.medium || '',
        large:
          pageContent.data?.images?.zipGateBackground?.sources?.large || '',
        xLarge:
          pageContent.data?.images?.zipGateBackground?.sources?.xLarge || '',
        small:
          pageContent.data?.images?.zipGateBackground?.sources?.small || '',
      },
    },
  };

  useEffect(() => {
    // initializing zipgate in case the zipcode is not available.
    if (!zipcode) {
      var event = new CustomEvent('react-zipgate-open', {
        detail: {
          hideCloseButton: true,
          showBackground: true,
        },
      });
      window.dispatchEvent(event);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`${brandVariation}`}>
      {zipcode && (
        <>
          {stationData.status === 'success' &&
          pageContent.status === 'success' ? (
            <ChargingLocatorContainer
              stations={stationData.data}
              pageContent={pageContent.data as IEVChargingPageContent}
              blur={false}
            />
          ) : (
            <ChargingLocatorContainer
              stations={[]}
              pageContent={{
                labels: {
                  cutline:
                    'Results are updated every 24 hours. Location of Coming Soon sites is subject to change.',
                },
                ctas: {},
                images: {
                  zipGateBackground: { alternativeText: '', sources: {} },
                },
                filters: [],
              }}
              blur={true}
            />
          )}
        </>
      )}
      <ZipGateModal {...zipgatePageContent} isContained isLocator />
    </div>
  );
};

export default EVChargingLocator;
